<ng-container *ngIf="entityId">
  <div class="toplines__heading"
       *ngIf="entity">Toplines</div>
  <app-toplines-display *ngIf="entity && extractedToplines.length > 0"
                        [appliedToplines]="entity?.appliedToplines"
                        [targetId]="entityId"
                        [targetType]="'Entity'"
                        (addClick)="handleAddClicked($event)"></app-toplines-display>
  <div *ngIf="entity && extractedToplines.length < 1"
       class="border-1 color--gray border-radius p-0075 mt-0075 mb-0100 align-center w-100">
    There are no toplines to display.
  </div>
</ng-container>
